import React from 'react'
import { Button, Grid, Box } from '@mui/material'
import {
  PickingInputData,
  PickingRoute,
  PickingRouteDetails,
  Position,
  StockKeepingUnit
} from '../../../interfaces/Picking/Picking'

import { PickingRouteProductInfo } from './PickingRouteProductInfo'
import { PickingProductForm } from './PickingProductForm'
import { NewPickingRouteHeader } from './NewPickingRouteHeader'
import { AddLPN } from './PickingProduct/AddLPN'

interface PickingProductProps {
  header?: JSX.Element
  pickingRoute?: PickingRoute
  pickingRouteDetails?: PickingRouteDetails
  handlePickUp: (inputData: PickingInputData) => void
  handleNotFound: () => void
  handleDetailButton: () => void
  handleLPNButton: () => void
  handlerOpenAndCloseDialogAlert: (showSeconds: number, message: string) => void
  requiredTote: boolean
  statePositionsScaned: string[]
  setStatePositionsScaned: React.Dispatch<React.SetStateAction<string[]>>
  configPickingRoutePositionScan: boolean
}

export const PickingProduct: React.FC<PickingProductProps> = ({
  pickingRoute,
  pickingRouteDetails,
  handlePickUp,
  handleNotFound,
  handleDetailButton,
  handleLPNButton,
  handlerOpenAndCloseDialogAlert,
  requiredTote,
  statePositionsScaned,
  setStatePositionsScaned,
  configPickingRoutePositionScan
}) => {
  const details: PickingRouteDetails =
    pickingRouteDetails || new PickingRouteDetails()
  const product: StockKeepingUnit =
    pickingRouteDetails?.product || new StockKeepingUnit()
  const position: Position = pickingRouteDetails?.position || new Position()
  const pendingQuantity = details.realQuantity - details.pickedQuantity
  const dunPacksQty =
    details.product?.dunQty &&
    Math.floor(pendingQuantity / details.product.dunQty)
  const dunUnitsQty =
    details.product?.dunQty && pendingQuantity % details.product.dunQty
  const initialInput: PickingInputData = {
    sku: '',
    quantity: 1,
    positionName: ''
  }

  const handleFormSubmit = (inputData: PickingInputData) => {
    handlePickUp(inputData)
  }

  // devuelve el realquantity para mostrar "/cantidad" dependiendo de la configuración picking por pieza
  const realQuantityByConfig = (): string => {
    if (
      pickingRouteDetails?.realQuantity !== undefined &&
      pickingRouteDetails?.realQuantity !== null
    ) {
      return `/${pickingRouteDetails.realQuantity.toString()}`
    } else {
      return ''
    }
  }

  return (
    <Box
      display='flex'
      flex='1'
      flexDirection='column'
      justifyContent='space-around'
    >
      <NewPickingRouteHeader
        pickingRoute={pickingRoute}
        position={position.positionName}
      />
      <PickingRouteProductInfo
        sku={product.sku}
        ean={product.ean13}
        qty={details.pickedQuantity}
        dunPacksQty={dunPacksQty}
        dunUnitsQty={dunUnitsQty}
        name={product.name}
        realQuantity={realQuantityByConfig()}
        isRecall={pickingRouteDetails?.isInRecall}
        batchNumber={product.batchNumber}
        expirationDate={product.expirationDate}
      />

      <Grid
        container
        spacing={2}
        direction='column'
        alignItems='center'
        justifyContent='center'
      >
        <Grid item xs={12}>
          <PickingProductForm
            pickingRouteDetails={pickingRouteDetails}
            initialInputData={initialInput}
            isInputQuantity={false}
            handleFormSubmit={handleFormSubmit}
            handlerOpenAndCloseDialogAlert={handlerOpenAndCloseDialogAlert}
            statePositionsScaned={statePositionsScaned}
            setStatePositionsScaned={setStatePositionsScaned}
            configPickingRoutePositionScan={configPickingRoutePositionScan}
          />
        </Grid>
        <Grid container item xs={12}>
          <Grid item xs={6} sm={6}>
            <Box padding='10px' paddingX={0} paddingY={0} textAlign={'center'}>
              <img
                style={{ maxWidth: '150px' }}
                src={
                  product.urlImagen
                    ? product.urlImagen
                    : 'https://via.placeholder.com/150/FF00000/FFFFFF%20?text=SIN IMAGEN'
                }
                alt={product.name}
              />
            </Box>
          </Grid>

          <Grid item xs={6} sm={6}>
            {requiredTote ? (
              `LPN/Tote: ${pickingRoute?.lpn || ''} `
            ) : (
              <AddLPN
                lpn={pickingRoute?.lpn || ''}
                handleLPNButton={handleLPNButton}
              />
            )}
          </Grid>
        </Grid>

        <Grid container item xs={12} spacing={3}>
          <Grid item xs={6}>
            <Button
              variant='contained'
              color='secondary'
              onClick={handleNotFound}
              size='small'
              fullWidth
            >
              No encontrado
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              variant='contained'
              color='primary'
              onClick={handleDetailButton}
              size='small'
              fullWidth
            >
              Detalle
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}
